import { BaseEntityDto, GetManyV2Dto } from '@fleet-beat/core';

export interface IftaLogsDto extends BaseEntityDto {
  id?: string;
  companyId?: string;
  truckId?: string;
  vehicleId?: string;
  kilometers?: number;
  miles?: number;
  state?: string;
  stateAbbr?: string;
  month?: number;
  quarter?: number;
  year?: number;
}

export interface GetIftaLogsParams extends GetManyV2Dto {
  months?: number[];
  quarters?: number[];
  year?: number;
  vehicles?: string[];
  states?: string[];
}

export interface IftaLogsByStateDto {
  stateAbbr: string;
  totalMiles: string;
  state?: string;
}
